import { ActionReducerMap } from '@ngrx/store';
import * as user from './user.reducers';
import * as events from './events.reducers';
import * as devicesStatus from './devices-status.reducers';
import * as devicesInfo from './devices-info.reducers';
import {FilterParams} from '../../models/events';
import * as filters from './filter.reducer';
import * as group from './group.reducer';
import * as fromGroupDetail from './group-detail.reducer';
import * as fromUserModule from './user-module.reducer';
import * as fromEventMaps from '../../my-features/event-map/reducers/event-map.reducer';
import * as fromHardwareFaultCode from '../../my-features/hardware/reducers/hardware-fault-code.reducer';
import * as fromHardwareFaultLevel from '../../my-features/hardware/reducers/hardware-fault-level.reducer';

export interface State {
  user: user.UsersState;
  events: events.EventsState;
  eventsFilterParams: FilterParams;
  devicesStatus: devicesStatus.DevicesStatusState;
  deviceDetails: devicesStatus.DevicesDetailsState;
  selectedDashboardStatus: number;
  devicesInfo: devicesInfo.DevicesInfoState;
  updateDevice: devicesInfo.UpdateDeviceInfoState;
  filters: filters.FiltersState;
  group: group.GroupdsState;
  groupDetail: fromGroupDetail.State;
  userModule: fromUserModule.UserModuleState;
  eventMaps: fromEventMaps.State;
  hardwareFaultCode: fromHardwareFaultCode.State;
  hardwareFaultLevel: fromHardwareFaultLevel.State;
}
export const reducers: ActionReducerMap<State> = {
  user: user.reducer,
  events: events.reducer,
  eventsFilterParams: events.eventParams,
  devicesStatus: devicesStatus.reducer,
  selectedDashboardStatus: devicesStatus.selectedDashboardStatusReducer,
  devicesInfo: devicesInfo.reducer,
  deviceDetails: devicesStatus.detailsReducer,
  updateDevice: devicesInfo.updateDeviceReducer,
  filters: filters.reducer,
  group: group.reducer,
  groupDetail: fromGroupDetail.reducer,
  userModule: fromUserModule.reducer,
  eventMaps: fromEventMaps.reducer,
  hardwareFaultCode: fromHardwareFaultCode.reducer,
  hardwareFaultLevel: fromHardwareFaultLevel.reducer
};
